export enum UserRole {
  ACCOUNT_ADMIN = 'account_admin',

  DOMAIN_ADMIN = 'domain_admin',
  REPORTING_USER = 'reporting_user',
  LINK_ADMIN = 'link_admin',
  QR_MANAGER = 'qr_manager',
  STANDARD_USER = 'standard_user',

  NO_ACCESS = 'no_access',
}

export enum RoleLayer {
  ACCOUNT = 'account',
  DOMAIN = 'domain',
}

export const ACCOUNT_ROLE_HIERARCHY: Partial<Record<UserRole, number>> = {
  [UserRole.ACCOUNT_ADMIN]: 100,
  [UserRole.QR_MANAGER]: 40,
};

export const DOMAIN_ROLE_HIERARCHY: Partial<Record<UserRole, number>> = {
  [UserRole.DOMAIN_ADMIN]: 100,
  [UserRole.REPORTING_USER]: 60,
  [UserRole.LINK_ADMIN]: 50,
  [UserRole.STANDARD_USER]: 30,
  [UserRole.NO_ACCESS]: 0,
};

export const ROLE_HIERARCHY: Record<UserRole, number> = {
  [UserRole.ACCOUNT_ADMIN]: 100,
  [UserRole.DOMAIN_ADMIN]: 80,
  [UserRole.REPORTING_USER]: 60,
  [UserRole.LINK_ADMIN]: 50,
  [UserRole.QR_MANAGER]: 40,
  [UserRole.STANDARD_USER]: 30,
  [UserRole.NO_ACCESS]: 0,
};

export const ROLE_DISPLAY_NAMES: Record<UserRole, string> = {
  [UserRole.ACCOUNT_ADMIN]: 'Account Admin',
  [UserRole.DOMAIN_ADMIN]: 'Domain Admin',
  [UserRole.REPORTING_USER]: 'Reporting User',
  [UserRole.LINK_ADMIN]: 'Link Admin',
  [UserRole.QR_MANAGER]: 'QR Manager',
  [UserRole.STANDARD_USER]: 'Standard User',
  [UserRole.NO_ACCESS]: 'No Access',
};


export const ROLE_DESCRIPTIONS: Record<UserRole, string> = {
  [UserRole.ACCOUNT_ADMIN]: 'Has full access to all features across all domains in the account.',
  [UserRole.DOMAIN_ADMIN]: 'Has access to all permissions within their assigned domain(s).',
  [UserRole.REPORTING_USER]: 'Has read-only access to view all pages within their domain.',
  [UserRole.LINK_ADMIN]: 'Can manage links and has access to all links within their domain.',
  [UserRole.QR_MANAGER]: 'Can manage QR templates and view their own templates and links.',
  [UserRole.STANDARD_USER]: 'Has basic permissions within their domain.',
  [UserRole.NO_ACCESS]: 'Has no permissions in this domain.',
};

export const ACCOUNT_LEVEL_ROLES: readonly UserRole[] = [
  UserRole.ACCOUNT_ADMIN,
  UserRole.QR_MANAGER,
] as const;

export const DOMAIN_LEVEL_ROLES: readonly UserRole[] = [
  UserRole.DOMAIN_ADMIN,
  UserRole.REPORTING_USER,
  UserRole.LINK_ADMIN,
  UserRole.STANDARD_USER,
  UserRole.NO_ACCESS,
] as const;

export const ADMIN_ROLES: readonly UserRole[] = [
  UserRole.ACCOUNT_ADMIN,
  UserRole.DOMAIN_ADMIN,
] as const;
